import { useTranslation } from 'react-i18next'

import { FieldGroup, FieldGroupHeader, FieldsTable } from '@/components/layout/field-row'
import { SelectOption } from '@/components/ui/select'
import { Building } from '@/reducers/types'

import { GeneralEditRow } from './general-edit-row'
import { getPlaceGeneralLayout } from './general-tab.constants'

interface GeneralEditFieldsProps {
  building: Building
  countryLabel: string
  isAdmin: boolean
  tagOptions: SelectOption<string>[]
  timezoneOptions: SelectOption<string>[]
}

export const GeneralEditFields = ({
  building,
  countryLabel,
  isAdmin,
  tagOptions,
  timezoneOptions,
}: GeneralEditFieldsProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <FieldsTable>
      {getPlaceGeneralLayout(isAdmin).map(({ group, rows }) => (
        <FieldGroup key={group}>
          <FieldGroupHeader>{t(`organisation:places.general.groups.${group}`)}</FieldGroupHeader>
          {rows.map((row) => (
            <GeneralEditRow
              key={row}
              building={building}
              countryLabel={countryLabel}
              isAdmin={isAdmin}
              row={row}
              tagOptions={tagOptions}
              timezoneOptions={timezoneOptions}
            />
          ))}
        </FieldGroup>
      ))}
    </FieldsTable>
  )
}
